import { sort } from "fast-sort";

export function getVisibleWorkoutItemAttributes<
  TAttribute extends { order: number; deletedAt: string | Date | null },
>(attributes: TAttribute[]): TAttribute[] {
  return sort(
    attributes.filter((attribute) => {
      return attribute.deletedAt === null;
    }),
  ).asc((attribute) => {
    return attribute.order;
  });
}
